import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CapabilityRoute from "@/components/CapabilityRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EnquiryList from "@/pages/EnquiryList";
import EnquiryDetail from "@/pages/EnquiryDetail";
import BulletinList from "@/pages/BulletinList";
import BulletinDetail from "@/pages/BulletinDetail";
import MachinesMaster from "@/pages/MachinesMaster";
import LineTracking from "@/pages/LineTracking";
import Masters from "@/pages/Masters";
import UsersPage from "@/pages/Users";
import RolesPermissions from "@/pages/RolesPermissions";
import EmailConfiguration from "@/pages/EmailConfiguration";
import NotificationsSettings from "@/pages/NotificationsSettings";
import CourierTemplates from "@/pages/CourierTemplates";
import SampleRegister from "@/pages/SampleRegister";
import PriceList from "@/pages/PriceList";
import SampleScan from "@/pages/SampleScan";
import FabricTrimRequest from "@/pages/FabricTrimRequest";
// --- CheckPoint (Visitor Entry) — merged from gate-check-6 ----------------
import CheckPointDashboard from "@/pages/gate-check/Dashboard";
import GateCheckIn from "@/pages/gate-check/GateCheckIn";
import VisitorLog from "@/pages/gate-check/VisitorLog";
import EmergencyView from "@/pages/gate-check/EmergencyView";
import Blacklist from "@/pages/gate-check/Blacklist";
import Vehicles from "@/pages/gate-check/Vehicles";
import Deliveries from "@/pages/gate-check/Deliveries";
import VisitorAnalytics from "@/pages/gate-check/Analytics";
import VisitorReports from "@/pages/gate-check/Reports";
import AdminGates from "@/pages/gate-check/AdminGates";
import AdminHosts from "@/pages/gate-check/AdminHosts";
import VisitorPass from "@/pages/gate-check/VisitorPass";
import PreRegisterVisitor from "@/pages/gate-check/PreRegisterVisitor";
import PublicVisitorPass from "@/pages/gate-check/PublicVisitorPass";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Public scan route — anonymous viewers get limited tag payload */}
            <Route path="/samples/scan/:qrId" element={<SampleScan />} />
            {/* Public visitor pass — no auth. Visitors open on their phone from a shared link. */}
            <Route path="/pass/:passId" element={<PublicVisitorPass />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/enquiries" element={<CapabilityRoute capability="view_enquiries"><EnquiryList /></CapabilityRoute>} />
              <Route path="/enquiries/:id" element={<CapabilityRoute capability="view_enquiries"><EnquiryDetail /></CapabilityRoute>} />
              <Route path="/bulletins" element={<CapabilityRoute capability="view_bulletins"><BulletinList /></CapabilityRoute>} />
              <Route path="/bulletins/machines" element={<CapabilityRoute capability="view_bulletins"><MachinesMaster /></CapabilityRoute>} />
              <Route path="/bulletins/:id" element={<CapabilityRoute capability="view_bulletins"><BulletinDetail /></CapabilityRoute>} />
              <Route path="/line-tracking" element={<CapabilityRoute capability="view_line_tracking"><LineTracking /></CapabilityRoute>} />
              <Route path="/samples" element={<CapabilityRoute capability="view_samples"><SampleRegister /></CapabilityRoute>} />
              <Route path="/price-list" element={<CapabilityRoute capability="view_price_list"><PriceList /></CapabilityRoute>} />
              <Route path="/fabric-trim" element={<CapabilityRoute capability="view_ftr_requests"><FabricTrimRequest /></CapabilityRoute>} />
              <Route path="/fabric-trim/:id" element={<CapabilityRoute capability="view_ftr_requests"><FabricTrimRequest /></CapabilityRoute>} />
              <Route path="/masters" element={<CapabilityRoute capability="view_masters"><Masters /></CapabilityRoute>} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/admin/roles-permissions" element={<RolesPermissions />} />
              <Route path="/admin/email-configuration" element={<EmailConfiguration />} />
              <Route path="/admin/notifications" element={<NotificationsSettings />} />
              <Route path="/admin/courier-templates" element={<CapabilityRoute capability="manage_courier_templates"><CourierTemplates /></CapabilityRoute>} />
              {/* CheckPoint (Visitor Entry) */}
              <Route path="/checkpoint" element={<CapabilityRoute capability="view_checkpoint"><CheckPointDashboard /></CapabilityRoute>} />
              <Route path="/checkpoint/checkin" element={<CapabilityRoute capability="checkpoint_checkin"><GateCheckIn /></CapabilityRoute>} />
              <Route path="/checkpoint/pre-register" element={<CapabilityRoute capability="pre_register_visitor"><PreRegisterVisitor /></CapabilityRoute>} />
              <Route path="/checkpoint/visitors" element={<CapabilityRoute capability="view_checkpoint"><VisitorLog /></CapabilityRoute>} />
              <Route path="/checkpoint/emergency" element={<CapabilityRoute capability="view_checkpoint"><EmergencyView /></CapabilityRoute>} />
              <Route path="/checkpoint/blacklist" element={<CapabilityRoute capability="manage_blacklist"><Blacklist /></CapabilityRoute>} />
              <Route path="/checkpoint/vehicles" element={<CapabilityRoute capability="view_checkpoint"><Vehicles /></CapabilityRoute>} />
              <Route path="/checkpoint/deliveries" element={<CapabilityRoute capability="view_checkpoint"><Deliveries /></CapabilityRoute>} />
              <Route path="/checkpoint/analytics" element={<CapabilityRoute capability="view_visitor_analytics"><VisitorAnalytics /></CapabilityRoute>} />
              <Route path="/checkpoint/reports" element={<CapabilityRoute capability="export_visitor_reports"><VisitorReports /></CapabilityRoute>} />
              <Route path="/checkpoint/admin/gates" element={<CapabilityRoute capability="manage_gates_hosts"><AdminGates /></CapabilityRoute>} />
              <Route path="/checkpoint/admin/hosts" element={<CapabilityRoute capability="manage_gates_hosts"><AdminHosts /></CapabilityRoute>} />
              <Route path="/checkpoint/pass/:id" element={<CapabilityRoute capability="view_checkpoint"><VisitorPass /></CapabilityRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
